module.exports = __webpack_public_path__ + "img/kinetikos-hero-pro.77041145.png";